export const Prices = [
  {
    _id: 0,
    name: "$0 to 5000",
    array: [0, 5000],
  },
  {
    _id: 1,
    name: "$5000 to 8000",
    array: [5000, 8000],
  },
  {
    _id: 2,
    name: "$8000 to 10000",
    array: [8000, 10000],
  },

  {
    _id: 3,
    name: "$10000 or more",
    array: [10000, 99999],
  },
];
